import React from 'react';
import styled from '@emotion/styled';

import DraftstarsLogo from './draftstars-logo.png';

const UpdateAppScreen = (props: Props) => {
  const appStoreDownloadLink =
    'https://apps.apple.com/us/app/draftstars-fantasy-sports/id1109446849';
  const googlePlayDownloadLink =
    'https://play.google.com/store/apps/details?id=com.draftstars.mobile';

  const updateApp = () => {
    if (props.platform === 'ios') {
      window.open(appStoreDownloadLink, '_blank');
    }
    if (props.platform === 'android') {
      window.open(googlePlayDownloadLink, '_blank');
    }
  };

  return (
    <Background>
      <Logo src={DraftstarsLogo} alt="Draftstars" />
      <LargeText>You are no longer using the up-to-date version of Draftstars.</LargeText>
      <Text>Please visit the App Store to update to the latest version.</Text>
      <UpdateButton onClick={updateApp}>UPDATE</UpdateButton>
    </Background>
  );
};

export default UpdateAppScreen;

interface Props {
  platform: string;
}

const Background = styled.div({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: 'calc(100vh - 50px)',
  width: '100vw',
  paddingLeft: 20,
  paddingRight: 20,
  zIndex: 99999,
  background: '#15202B'
});

const Logo = styled.img({
  maxWidth: 250,
  marginBottom: 30
});

const Text = styled.p({
  color: '#FFFFFF',
  margin: 0,
  fontSize: 15,
  textAlign: 'center',
  marginTop: 20
});

const LargeText = styled(Text)({
  fontSize: 24,
  fontWeight: 600
});

const UpdateButton = styled.button({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: 40,
  color: '#000000',
  background: '#FF0056',
  width: 150,
  height: 40,
  lineHeight: 30,
  padding: 5,
  borderRadius: 20,
  fontSize: 24,
  fontWeight: 600,
  outline: 'none'
});
